import { Section } from '@react-email/components';

const section = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <Section
                {...attributes}
                className="email-section"
                {...element.attributes}
            >
                {children}
            </Section>
        );
    },
    PreviewElement: ({ attributes, children }) => {
        return <Section {...attributes}>{children}</Section>;
    },
};

export default section;
